import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store";
import { getShopInfo } from "../../slices/ShopInfo/thunk";
import { getPrimaryShopId } from "../../helpers/shop";
import userAvatar from "../../assets/img/core-img/logo-small.png";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";
import HomeLogoLink from "../../Components/Common/HomeLogoLink";

const formatStatus = (status: any): string => {
    if (status === 0 || status === "0") {
        return "Tạm ngưng hoạt động";
    }

    return "Đang hoạt động";
};

const ShopInfo = () => {
    const dispatch = useDispatch<AppDispatch>();
    const authUser = useSelector((state: any) => state.auth?.user);
    const { shop, loading, error } = useSelector((state: any) => state.ShopInfo);

    const shopId = useMemo(() => getPrimaryShopId(authUser), [authUser]);

    useEffect(() => {
        if (shopId) {
            dispatch(getShopInfo(shopId));
        }
    }, [dispatch, shopId]);

    const avatarUrl = shop?.image || shop?.avatar || userAvatar;
    const toneColor = shop?.tone_color ?? shop?.toneColor;

    const shopLatitude = shop?.latitude === null || shop?.latitude === undefined || shop?.latitude === "" ? "--" : shop.latitude;
    const shopLongitude = shop?.longitude === null || shop?.longitude === undefined || shop?.longitude === "" ? "--" : shop.longitude;
    const shopAltitude = shop?.altitude === null || shop?.altitude === undefined || shop?.altitude === "" ? "--" : shop.altitude;

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                    <HomeLogoLink className="me-2" />

                    <div className="page-heading">
                        <h6 className="mb-0">Thông tin quán</h6>
                    </div>

                    <HeaderSidebarToggle className="ms-2" />
                </div>
            </div>

            <div className="page-content-wrapper">
                <div className="container">
                    <div className="profile-wrapper-area py-3">
                        <div className="card user-info-card">
                            <div className="card-body p-4 d-flex align-items-center">
                                <div className="user-profile me-3">
                                    <img src={avatarUrl} alt={shop?.name ?? "Shop"} />
                                </div>
                                <div className="user-info">
                                    {/*<p className="mb-0 text-white">{shop?.slug ? `@${shop.slug}` : "@"}</p>*/}
                                    <h5 className="mb-0 text-white">{shop?.name ?? "Chưa có thông tin quán"}</h5>
                                </div>
                            </div>
                        </div>

                        <div className="card user-data-card">
                            <div className="card-body">
                                {loading && <p className="text-center mb-3">Đang tải thông tin...</p>}
                                {error && <p className="text-danger mb-3 text-center">{error}</p>}
                                {!loading && !error && (
                                    <>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-storefront-outline"></i>
                                                <span>Tên quán</span>
                                            </div>
                                            <div className="data-content">{shop?.name ?? "--"}</div>
                                        </div>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-link-variant"></i>
                                                <span>Slug</span>
                                            </div>
                                            <div className="data-content">{shop?.slug ?? "--"}</div>
                                        </div>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-phone"></i>
                                                <span>Điện thoại</span>
                                            </div>
                                            <div className="data-content">{shop?.phone ?? "--"}</div>
                                        </div>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-map-marker"></i>
                                                <span>Địa chỉ</span>
                                            </div>
                                            <div className="data-content">{shop?.address ?? "--"}</div>
                                        </div>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-crosshairs-gps"></i>
                                                <span>Vị trí quán</span>
                                            </div>
                                            <div className="data-content text-end">
                                                <div>Lat: {shopLatitude}</div>
                                                <div>Lng: {shopLongitude}</div>
                                                <div>Alt: {shopAltitude}</div>
                                            </div>
                                        </div>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-palette-outline"></i>
                                                <span>Tông màu</span>
                                            </div>
                                            <div className="data-content d-flex align-items-center justify-content-end gap-2 flex-grow-1 text-end">
                                                <span>{toneColor ?? "--"}</span>
                                                {toneColor && (
                                                    <span
                                                        className="rounded-circle border"
                                                        style={{
                                                            width: 16,
                                                            height: 16,
                                                            backgroundColor: toneColor,
                                                            display: "inline-block",
                                                        }}
                                                    ></span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="single-profile-data d-flex align-items-center justify-content-between">
                                            <div className="title d-flex align-items-center">
                                                <i className="mdi mdi-check-circle-outline"></i>
                                                <span>Trạng thái</span>
                                            </div>
                                            <div className="data-content">{formatStatus(shop?.status)}</div>
                                        </div>
                                    </>
                                )}

                                <div className="edit-profile-btn mt-3">
                                    <Link className="btn btn-primary btn-lg w-100" to="/shop/info/edit">
                                        <i className="mdi mdi-pencil me-2"></i>Chỉnh sửa thông tin
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ShopInfo;
